import React, { PureComponent } from 'react';
import cn from 'classnames';
import Select from '../common/Select';
import { Label, FormGroup } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { string, number, array, func } from 'prop-types';

class FlowSources extends PureComponent {
  static propTypes = {
    sourceId: number,
    sources: array.isRequired,
    onSiteChange: func.isRequired,
    error: string,
  };

  static defaultProps = {
    sources: [],
    sourceId: null,
    error: '',
  };

  render() {
    const { sourceId, sources, onSiteChange, error, theme } = this.props;

    return (
      <FormGroup className={cn('flow-source', 'form-group-upper-label', { 'has-error': error })}>
        <Label for="sources">
          <FormattedMessage id="flow.form.source" defaultMessage="Source" />
        </Label>

        <Select
          id="sources"
          name="source-id"
          clearable={false}
          value={sourceId}
          onChange={onSiteChange}
          options={sources.map(({ title: label, id: value }) => ({ value, label }))}
        />
        {error && <small className="form-text">{error}</small>}
      </FormGroup>
    );
  }
}

export default FlowSources;
